<ul class="filters-status-subsection">
    <li *ngFor="let st of status" (click)="onSelect(st)">
        <span class="filter-subtitle">{{st.name}}</span>
    </li>
</ul>
